<!-- 지역관리 지역 추가/수정 -->
<template>
  <div>
    <admin-box-item title="Featured 지역 추가/수정" :useTab="false">
      <div class="columns is-multiline">
        <div class="column is-full">
          <admin-form-item label="상위 지역 선택*"
                           desc="* 상위지역을 선택하면 자동으로 하위지역으로 들어갑니다. 상위지역을 추가하시려는 경우 '없음'을 선택해주세요.">
             <span class="select">
                <select v-model="value.featured.sido" @change="chgSido">
                  <option value="" selected>없음</option>
                  <option
                    v-for="item in value.upper_list" :key="item.value"
                    :value="item.value"
                  >{{ item.label }}</option>
                </select>
              </span>
          </admin-form-item>
        </div>

        <div class="column is-full">
          <admin-form-item label="Featured 지역명*">
            <input class="input" v-model="value.featured.title">
          </admin-form-item>
        </div>

        <div class="column is-full">
          <admin-form-item label="매핑할 주소">
            <div class="modal-address">
              <!-- 상위 항목(시도)일 경우 -->
              <div class="modal-tag"
                v-if="featuredType === 'sido'"
                v-for="(tag, index) in selectedSidoList" :key="tag.value">
                <span>{{ tag.label }}</span>
                <i class="material-icons"
                  @click="delTag(index)">close</i>
              </div>
              <!-- 하위 항목일 경우 -->
              <div class="modal-tag"
                v-if="featuredType === 'item'"
                v-for="(tag, index) in value.featured.region" :key="index">
                <span>{{ tag.full_text }}</span>
                <i class="material-icons"
                  @click="delTag(index)">close</i>
              </div>
              <!-- 입력창 -->
              <div style="position: relative;flex:1;min-width:150px">
                <input class="input"
                  :value="value.map_region"
                  @input="e => { mapping(e.target.value) }">
                <!-- 하위 항목일 경우 -->
                <div class="lp-box"
                  v-if="featuredType === 'item' && value.boxes.length > 0">
                  <div
                    v-for="box in value.boxes" :key="box.full_text"
                    @click="selectBox(box)">{{ box.full_text }}</div>
                </div>
                <!-- 상위 항목(시도)일 경우 -->
                <div class="lp-box"
                  v-if="featuredType === 'sido'">
                  <div
                    v-for="option in filteredSidoOptions" :key="option.label"
                    @click="selectBox(option)">{{ option.label }}</div>
                </div>
              </div>
            </div>
          </admin-form-item>
        </div>
      </div>

      <div class="btn-group-justify-end" style="margin-top:150px">
        <button class="button is-light" @click="cancelModal">취소</button>
        <button class="button is-primary" @click="saveData">저장</button>
      </div>
    </admin-box-item>
  </div>
</template>

<script>

  import AdminFormItem from "../admin/AdminFormItem";

  export default {
    components: {
      AdminFormItem,
    },

    props: ['data'],

    data() {
      return {
        value: {
          featured: {
            id: 0,
            sido: '',
            title: '',
            region: []
          },
          map_region: '',
          region_store: [],
          boxes: [],
          upper_list: []
        },

        // featuredType === 'sido'
        sidoList: [],
        selectedSidoList: [],
      };
    },

    computed: {
      upperRegion() {
        let partner = find(this.value.upper_list, 'value', this.value.featured.sido);
        if (partner !== undefined)
          return partner.label;
        else
          return '';
      },

      filteredSidoOptions() {
        let options = [];
        this.sidoList.forEach(sido => {
          // 이미 선택된 시도는 패스.
          if (this.selectedSidoList.find(selected => sido.value === selected.value)) {
            return;
          }
          options.push({
            value: sido.id,
            label: sido.label,
          });
        });
        return options;
      },

      /**
       * '없음'일 경우 'sido', 그외에는 'item'.
       */
      featuredType() {
        return (this.value.featured.sido === '') ? 'sido' : 'item';
      },
    },

    watch: {
      data(n) {
        if (n) {
          this.value = n;
        }
      }
    },

    created() {
      this.value = this.data;

      this.getSidoList();
    },

    methods: {
      cancelModal() {
        this.$store.commit('cancelModal');
      },

      // 상위지역 선택시 시도에 맞는 지역 데이터 가져오기
      chgSido(e) {
        this.value.featured.sido = e.target.value;

        // '없음'일 경우 패스.
        if (this.value.featured.sido === '') {
          return;
        }
        //this.featured.sido = find(this.selectOptions, 'value', e);
        if (this.value.featured.sido === undefined) return;
        this.$axios.get('admin/address/default/sido/' + e.target.value + '/all').then(res => {
          if (res.status === 200) {
            this.value.region_store = res.data;
          }
        })
      },

      delTag(index) {
        if (this.featuredType === 'sido') {
          this.selectedSidoList.splice(index, 1);
        }
        if (this.featuredType === 'item') {
          this.value.featured.region.splice(index, 1)
        }
      },

      // 박스 지역 선택
      selectBox(box) {
        // 시도 선택 시.
        if (this.featuredType === 'sido') {
          this.selectedSidoList.push(box);
        }

        // 하위 지역 선택 시.
        if (this.featuredType === 'item' && box != undefined) {
          this.value.map_region = ''
          console.log(box)
          if (box.sigungu_id) {
            this.value.featured.region.push({
              sigungu_id: box.sigungu_id,
              full_text: box.full_text,
              dong_id: box.dong_id,
            });
          } else if (box.dong_id) {
            this.value.featured.region.push({
              dong_id: box.dong_id,
              full_text: box.full_text
            });
          }
          this.value.boxes = [];
        }
      },

      // 등록하기
      saveData() {
        // 유효값 검증
        const validation = this.preSaveValidate();
        if (!validation.valid) {
          this.toast(validation.message);
          return;
        }

        // 시도 저장할 시.
        if (this.featuredType === 'sido') {
          let data = {
            name: this.value.featured.title,
            sido_set: (() => {
              let set = [];
              this.selectedSidoList.forEach(sido => {
                set.push(sido.value);
              });
              return set;
            })(),
          };

          this.$axios.post('admin/address/featured/sido', data)
            .then(res => {
              if (res.status === 200) {
                this.toast('저장되었습니다.');
                this.$store.commit('closeModal');
              }
            });

          return;
        }

        let data = {
          id: this.value.featured.id,
          name: this.value.featured.title,
          featured_sido_id: this.value.featured.sido,
          address: this.value.featured.region
        }
        if (this.value.featured.id === 0) {
          this.$axios.post('admin/address/featured/item', data).then(res => {
            if (res.status === 200) {
              this.toast('저장되었습니다.');
              this.$store.commit('closeModal');
            }
          })
        }
        else {
          this.$axios.patch('admin/address/featured/item/' + this.value.featured.id, data).then(res => {
            if (res.status === 200) {
              this.toast('저장되었습니다.');
              this.$store.commit('closeModal');
            }
          })
        }
      },

      // 매핑할주소 input에 주소를 적으면 region_store의 데이터와 matching
      mapping(map_region) {
        this.value.map_region = map_region;
        var region = this.value.region_store
        let boxes = []
        if (map_region !== '')
          for (var i = 0; i < region.length; i++) {
            if (region[i].full_text.match(map_region)) {
              if (region[i].sigungu_id) {
                boxes.push({
                  sigungu_id: region[i].sigungu_id,
                  full_text: region[i].full_text,
                  dong_id: region[i].dong_id || null,
                });
              }
              else if (region[i].dong_id) {
                boxes.push({
                  dong_id: region[i].dong_id,
                  full_text: region[i].full_text
                })
              }
            }
          }
        this.value.boxes = boxes
      },

      /**
       * 저장하기 전, 값이 입력되었는지 검사.
       */
      preSaveValidate() {
        const { sido, title } = this.value.featured;
        let result = {
          valid: (title !== ''),
          message: '',
        };
        if (result.valid) {
          return result;
        }
        // result.message = (!sido) ? '상위 지역을' : '지역명을';
        result.message = '지역명을';
        result.message += ' 입력(선택) 하세요.';
        return result;
      },


      /**
       * 기본 시도 데이터를 가져옴.
       */
      getSidoList() {
        this.$axios.get('public/address/basic/sido')
          .then(res => {
            this.sidoList = res.data;
          });
      },
    }
  }
</script>
<style lang="stylus" type="stylus" scoped>

  .modal-address
    display flex
    flex-wrap wrap
    background #f2f7f8
    padding 4px

  .modal-tag
    margin-right 4px
    padding 5px 12px 2px 12px
    border 1px solid #eee
    border-radius 4px
    background white

  .modal-tag i
    margin-left 8px
    font-size 0.9rem

  .modal-input-mapping
    margin-top 3px
    width 100%

  .lp-box
    position absolute
    background white
    z-index 1
    top 30px
    margin-top 8px
    border 1px solid #eee
    border-radius 3px
    padding 12px
    max-height 180px
    overflow-y auto

  .lp-box > div
    cursor pointer

  .lp-box > div:hover
    color $primary
</style>
